module.exports = __webpack_public_path__ + "img/104.3.ffab09a4.png";